/* USDO variant availability
   Greys out the option swatches a shopper cannot actually buy where they live.

   Reads the same per-variant, per-state numbers the ZIP availability block
   already puts on the page, and the shared region from window.USDORegion.
   Reuses the theme's own "!unavailable" treatment (grey fill, diagonal strike)
   so it looks native. Every mark we add is tagged with data-usdo-marked so we
   can take it back off cleanly when the shopper changes their ZIP.

   The theme re-renders the option list on every selection, which wipes our
   classes, so we re-apply after variant:update. */
(function () {
  if (window.USDOVariantAvailability) return;

  var MARK = "usdo-region-out";
  var THEME_CLASS = "!unavailable";
  var NOTE_CLASS = "usdo-region-note";
  var PHONE = "877-226-2244";

  function readData() {
    var el = document.querySelector(".zipavail-data");
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // -1 means no quantity limit (untracked, or set to keep selling).
  // A state we have no number for is left alone rather than guessed at.
  function sellable(avail, state) {
    if (!avail) return true;
    var raw = parseInt(avail[state], 10);
    if (isNaN(raw)) return true;
    return raw === -1 || raw > 0;
  }

  function labelFor(input) {
    return input.closest("label") ||
           (input.id ? document.querySelector('label[for="' + input.id + '"]') : null);
  }

  function clearMarks() {
    var marked = document.querySelectorAll("[data-usdo-marked]");
    for (var i = 0; i < marked.length; i++) {
      var inp = marked[i];
      inp.classList.remove(MARK);
      if (inp.getAttribute("data-usdo-themeclass")) {
        inp.classList.remove(THEME_CLASS);
        inp.removeAttribute("data-usdo-themeclass");
      }
      inp.removeAttribute("data-usdo-marked");
      var lab = labelFor(inp);
      if (lab && lab.getAttribute("data-usdo-title")) {
        lab.removeAttribute("title");
        lab.removeAttribute("data-usdo-title");
      }
    }
    var notes = document.querySelectorAll("." + NOTE_CLASS);
    for (var j = 0; j < notes.length; j++) {
      if (notes[j].parentNode) notes[j].parentNode.removeChild(notes[j]);
    }
  }

  function apply() {
    clearMarks();

    var R = window.USDORegion;
    if (!R) return;
    var region = R.get();
    if (!region) return;

    var state = region.state;
    // Alaska, Hawaii and Puerto Rico are quoted by hand, so we mark nothing.
    if (R.OFFSHORE && R.OFFSHORE[state]) return;

    var data = readData();
    if (!data) return;

    var stateName = (R.STATE_NAMES && R.STATE_NAMES[state]) || state;
    var selectors = document.querySelectorAll("product-variant-selector");
    if (!selectors.length) return;

    for (var s = 0; s < selectors.length; s++) {
      var sel = selectors[s];
      var inputs = sel.querySelectorAll("input[data-option-value-id]");
      var hit = 0;

      for (var i = 0; i < inputs.length; i++) {
        var inp = inputs[i];
        var vid = inp.getAttribute("data-variant-id");
        // No variant id means no such combination exists. The theme already
        // marks those, so there is nothing for us to add.
        if (!vid) continue;
        if (sellable(data[vid], state)) continue;

        inp.classList.add(MARK);
        inp.setAttribute("data-usdo-marked", "1");
        if (!inp.classList.contains(THEME_CLASS)) {
          inp.classList.add(THEME_CLASS);
          inp.setAttribute("data-usdo-themeclass", "1");
        }
        var lab = labelFor(inp);
        if (lab && !lab.getAttribute("title")) {
          lab.setAttribute("title", "Not stocked for " + stateName + " right now");
          lab.setAttribute("data-usdo-title", "1");
        }
        hit++;
      }

      if (hit) {
        var note = document.createElement("p");
        note.className = NOTE_CLASS;
        note.textContent = "Options shown greyed out are not stocked for " + stateName +
          " right now. Call us at " + PHONE + " for a lead time.";
        if (sel.parentNode) sel.parentNode.insertBefore(note, sel.nextSibling);
      }
    }
  }

  // The option list is replaced wholesale on each selection, so run after the
  // synchronous handlers, then once more in case the swap was deferred.
  function reapply() {
    setTimeout(apply, 0);
    setTimeout(apply, 140);
  }

  document.addEventListener("usdo:region", apply);
  document.addEventListener("usdo:zipdata", apply);
  document.addEventListener("variant:update", reapply);
  document.addEventListener("variant:change", reapply);
  document.addEventListener("shopify:section:load", reapply);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", apply);
  } else { apply(); }

  window.USDOVariantAvailability = { apply: apply, clear: clearMarks };
})();
